import { cn } from "@/lib/utils";

/**
 * Peças de estilo da landing que não são componente.
 *
 * Moram fora de `primitives.tsx` porque o react-refresh só recarrega arquivo
 * que exporta apenas componentes. As cores vêm todas dos tokens de
 * `index.css` — nada de `blue-500` aqui.
 */

/** Largura de leitura do site: a mesma em toda seção, para as bordas baterem. */
export const CONTAINER = "mx-auto w-full max-w-6xl px-4 sm:px-6";

/** Respiro vertical padrão entre seções. */
export const SECTION_Y = "py-20 md:py-28";

type ButtonVariant = "primary" | "secondary" | "inverse" | "ghost-inverse";
type ButtonSize = "md" | "lg";

/**
 * Um só `primary` por vista: a cor cheia marca a ação principal, e duas
 * disputando o olho viram nenhuma. O resto é `secondary`. Na faixa escura
 * (`--lp-band`) a ação principal é `inverse` e a secundária `ghost-inverse`.
 */
export function buttonClass(
  variant: ButtonVariant = "primary",
  size: ButtonSize = "md",
  className?: string,
) {
  return cn(
    "lp-press inline-flex items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap",
    "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
    size === "md" ? "h-11 px-5 text-sm" : "h-12 px-6 text-base",
    variant === "primary" &&
      "bg-primary text-primary-foreground shadow-sm hover:bg-primary/90",
    variant === "secondary" &&
      "bg-card text-foreground shadow-xs ring-1 ring-border hover:bg-accent",
    variant === "inverse" &&
      "bg-lp-band-foreground text-lp-band hover:bg-lp-band-foreground/90 focus-visible:outline-lp-band-foreground",
    variant === "ghost-inverse" &&
      "text-lp-band-foreground ring-1 ring-lp-band-foreground/25 hover:bg-lp-band-foreground/10 focus-visible:outline-lp-band-foreground",
    className,
  );
}

/** Rola até uma seção da home sem trocar a URL (o cabeçalho é fixo e a
 *  folga dele vem do `scroll-margin-top` em `.landing-root`). */
export function scrollToSection(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}
